module.exports = __webpack_public_path__ + "static/media/IMG_9046.ac26ae2b.JPG";